/**
 * Shared CSV export utility.
 * Generates a CSV file from headers + rows and triggers a browser download.
 *
 * @param {string} filename - e.g. 'vbc-report-2026-05-07.csv'
 * @param {string[]} headers - column header names
 * @param {Array<Array<string|number|null>>} rows - data rows (each row is an array of cell values)
 */
export function downloadCSV(filename, headers, rows) {
  const escape = (val) => {
    const s = val === null || val === undefined ? '' : String(val);
    return `"${s.replace(/"/g, '""')}"`;
  };
  const csv = [
    headers.map(escape).join(','),
    ...rows.map((row) => row.map(escape).join(',')),
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
